// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-apps_next_src_app_home_models_configurator_ts-apps_next_src_app_home_services_studio_-c1abf6":"814fddb360b30223","apps_next_src_app_link_link_module_ts":"4cd58c0287a91a97","apps_next_src_app_home_home_module_ts":"4a64627c86ba0581"}[chunkId] + ".js";
};